import { AbstractControl, ValidationErrors } from '@angular/forms';

/** Mirrors the backend's validate_password (api/v1/auth/password_util.py): a letter and a number. */
export function passwordStrengthValidator(control: AbstractControl): ValidationErrors | null {
  const val: string = control.value || '';
  if (!val) return null;
  if (!/[a-zA-Z]/.test(val)) return { passwordNoLetter: true };
  if (!/[0-9]/.test(val)) return { passwordNoNumber: true };
  return null;
}
